import ReportLayoutHeader from '@app/components/reports/components/report-layout-header';
import { Icons } from '@shared/components/content/icons';
import { Button } from '@shared/components/ui/button';
import { CopyButton } from './copy-button';

interface SecrReportLayoutHeaderProps {
  reportUuid: string;
  onBack: () => void;
  onCopyAll: () => Promise<void> | void;
  onDownload: () => void;
}

export function SecrReportLayoutHeader({
  reportUuid,
  onBack,
  onCopyAll,
  onDownload,
}: SecrReportLayoutHeaderProps) {
  return (
    <ReportLayoutHeader
      reportType="ccf"
      reportUuid={reportUuid}
      onBack={onBack}
      backLabel="Back to configuration"
      customActions={
        <>
          <CopyButton
            onCopy={onCopyAll}
            variant="ghost"
            className="text-primary-50 hover:bg-transparent hover:text-primary-300"
          />
          <Button variant="outline" onClick={onDownload}>
            <Icons.download className="mr-1 size-4" />
            Download
          </Button>
        </>
      }
    />
  );
}
